import React from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Popover,
    PopoverBody,
    PopoverHeader,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Can } from '../Can';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class TimesheetExportGenerateButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            showPopover: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    handleButtonClick = () => {
        if (this.isExportButtonDisabled()) {
            return;
        }

        if (!this.isApprovedStatusSelected()) {
            this.setState({ showPopover: !this.state.showPopover });
            return;
        }

        this.setState({ showModal: true, showPopover: false });
    };

    togglePopover = () => {
        this.setState({ showPopover: !this.state.showPopover });
    };

    isExportButtonDisabled = () => {
        const { gridOptions, isExporting } = this.props;

        if (isExporting) {
            return true;
        }

        if (
            !gridOptions ||
            !gridOptions.api ||
            !gridOptions.api.getFilterModel
        ) {
            return true;
        }

        return false;
    };

    isApprovedStatusSelected = () => {
        const { gridOptions } = this.props;

        if (
            !gridOptions ||
            !gridOptions.api ||
            !gridOptions.api.getFilterModel
        ) {
            return false;
        }

        const filterModel = gridOptions.api.getFilterModel();

        return filterModel.timesheetStatusId?.value == TimesheetStatus.Approved;
    };

    localExportClick = async () => {
        const { onExportClick } = this.props;

        await onExportClick();

        this.setState({ showModal: false });
    };

    render() {
        const { isExporting, timesheetExportEnabled } = this.props;

        const { showModal, showPopover } = this.state;

        if (!timesheetExportEnabled) {
            return null;
        }

        const exportButtonDisabled = this.isExportButtonDisabled();
        const isApprovedStatusSelected = this.isApprovedStatusSelected();

        const exportIcon = isExporting ? (
            <FontAwesomeIcon
                icon={faCircleNotch}
                className="fa-spin mr-2"
                size="sm"
            />
        ) : (
            <FontAwesomeIcon icon={faArchive} className="mr-2" size="sm" />
        );

        return (
            <>
                <Can I="export" a="timesheet">
                    <span className="timesheet-management-action-button-wrap">
                        <Button
                            size="sm"
                            color="danger"
                            id="timesheetExportButton"
                            onClick={this.handleButtonClick}
                            disabled={exportButtonDisabled}
                            outline={!isApprovedStatusSelected}
                        >
                            {exportIcon}
                            Generate New Export
                        </Button>
                    </span>
                    <Popover
                        isOpen={showPopover && !isApprovedStatusSelected}
                        target="timesheetExportButton"
                        toggle={this.togglePopover}
                        placement="bottom"
                    >
                        <PopoverHeader>Cannot Generate Export</PopoverHeader>
                        <PopoverBody>
                            To generate a new export, please select a Status of
                            "Approved" and double check that one or more
                            timesheets have been approved and are pending
                            export.
                        </PopoverBody>
                    </Popover>
                </Can>

                <Modal isOpen={showModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Generate New Export - Timesheets and Time Off Requests
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            When exporting, only the date filter range will be
                            honored. Job, crew lead, timesheet number, and
                            timesheet type filters are ignored by the export
                            process.
                        </div>
                        <div>
                            If there are no approved timesheets awaiting export,
                            a new export will not be generated.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.localExportClick}>
                            Ok
                        </Button>
                        <Button
                            color="secondary"
                            className="ml-1"
                            onClick={this.toggleModal}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
